/** Launch's part of "Download my data": the caller's files here. */
export const myDataApi = '/launch/v1/me/data'
